import type { LegalDocumentEntry } from '../types/legalTypes'

export const LEGAL_DOCUMENT_SLUG = {
  TERMS: 'terms',
  PRIVACY: 'privacy',
  RISK: 'risk',
} as const

// Listed in reading order: what you agree to, what we do with your data, then
// what can go wrong.
export const LEGAL_DOCUMENTS: readonly LegalDocumentEntry[] = [
  {
    slug: LEGAL_DOCUMENT_SLUG.TERMS,
    title: 'Terms & Conditions',
    summary:
      'How selling through the Seller Portal works — who can sell, your obligations, settlement and fees.',
    icon: 'file',
  },
  {
    slug: LEGAL_DOCUMENT_SLUG.PRIVACY,
    title: 'Privacy Policy',
    summary: 'The personal data we collect when you sell, how we use it, and who we share it with.',
    icon: 'lock',
  },
  {
    slug: LEGAL_DOCUMENT_SLUG.RISK,
    title: 'Risk Policy',
    summary: 'The risks of selling through an offering, including funding, timing and price.',
    icon: 'shield',
  },
]
